import { createAllowlistGuard } from "@next-platform/packages-ts-types";
/**
 * Client-side categories used by shared retry and block-removal policy.
 */
export const PageBlockTransportErrorCategory = {
    TERMINAL: "terminal",
    TRANSIENT: "transient",
    UNEXPECTED: "unexpected",
};
export const PAGE_BLOCK_TRANSPORT_ERROR_CATEGORIES = Object.values(PageBlockTransportErrorCategory);
/**
 * Runtime type guard for `PageBlockTransportErrorCategory`.
 */
export const isPageBlockTransportErrorCategory = createAllowlistGuard(PAGE_BLOCK_TRANSPORT_ERROR_CATEGORIES);
